// Get the URL parameters
const urlParams = new URLSearchParams(window.location.search);
// Get the value of the "inquiry" parameter from the URL
const inquiryValue = urlParams.get('inquiry');

if (inquiryValue) {
    const textarea = document.querySelector('.contact-form textarea');
    // Use MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver(function(mutations) {
        // Check if the textarea is available in the DOM
        const textarea = document.querySelector('.contact-form textarea');
        if (textarea) {
            textarea.value = `Hello, I am interested in the ${inquiryValue}.`;
            // Disconnect the observer after the textarea is found and updated
            observer.disconnect();
        }
    });
    // Start observing the document body for changes
    observer.observe(document.body, { childList: true, subtree: true });
}